import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Portfolio from "@meetyoo/components/src/components/Portfolio";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ErrorModal from "@meetyoo/components/src/components/Modal/ErrorModal";
import { moveEVN, restEVNError } from "../../../actions/billing";
import { defaultPasscodeTheme } from "../../../constants/passCodeUtils";

const useStyles = makeStyles(theme => ({
  ...defaultPasscodeTheme(theme),
  innercontainer: {
    display: "inline-flex",
  },
  container: {
    textAlign: "center",
    display: "inline",
  },
  button: {
    margin: theme.spacing(3, 0, 2, 2),
  },
  patternValidate: {
    "&:invalid": {
      background: "#F08080",
    },
  },
}));

export const BillingEventCapsComponent = ({ requestFn, stateErrorMessage, resetFn }) => {
  const classes = useStyles();

  const [openError, setOpenError] = useState(false);
  const [fromDocumentNo, setFromDocumentNo] = useState(0);
  const [toDocumentNo, setToDocumentNo] = useState(0);
  const [makeRequest, setMakeRequest] = useState(false);
  useEffect(() => {
    const request = async () => {
      if (makeRequest) {
        await requestFn(fromDocumentNo, toDocumentNo);
        setMakeRequest(false);
      }
    };
    request();
  }, [fromDocumentNo, toDocumentNo, setMakeRequest, requestFn, makeRequest]);

  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    if (stateErrorMessage !== errorMessage && stateErrorMessage === "400 - Bad Request") {
      setOpenError(true);
      setErrorMessage("Contract Number seems not existing");
    } else if (stateErrorMessage !== errorMessage) {
      setOpenError(true);
      setErrorMessage(stateErrorMessage);
    }
  }, [stateErrorMessage, errorMessage, setErrorMessage, setOpenError]);

  const handleCloseErrorModal = () => {
    setOpenError(false);
    setErrorMessage("");
    resetFn();
  };

  return [
    <Portfolio
      title="EVN-Umhängen"
      key="container-contract_reset"
      component={
        <div className={classes.container}>
          <div>
            <div className={classes.innercontainer}>
              <TextField
                className={classes.textField}
                label="From old Document Number"
                value={fromDocumentNo}
                onChange={event => setFromDocumentNo(event.target.value)}
                margin="normal"
                inputProps={{ className: classes.patternValidate, pattern: "[A-Z0-9-]*" }}
              />
              <TextField
                className={classes.textField}
                label="To new Document Number"
                value={toDocumentNo}
                onChange={event => setToDocumentNo(event.target.value)}
                margin="normal"
                inputProps={{ className: classes.patternValidate, pattern: "[A-Z0-9-]*" }}
              />
              <Button
                disabled={makeRequest}
                variant="contained"
                className={classes.button}
                onClick={() => {
                  setMakeRequest(true);
                }}
              >
                Move
              </Button>
            </div>
          </div>
        </div>
      }
    />,
    <ErrorModal
      key="error"
      handleCloseErrorModal={handleCloseErrorModal}
      openErrorModal={openError}
      errorMessage={errorMessage}
    />,
  ];
};

BillingEventCapsComponent.propTypes = {
  requestFn: PropTypes.func.isRequired,
  stateErrorMessage: PropTypes.string.isRequired,
  resetFn: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  stateErrorMessage: state.billing.errorMessageEvn,
});

const mapDispatchToProps = dispatch => ({
  requestFn: async (fromDocumentNo, toDocumentNo) => {
    await dispatch(moveEVN(fromDocumentNo, toDocumentNo));
  },
  resetFn: () => dispatch(restEVNError()),
});

const BillingEventCaps = connect(
  mapStateToProps,
  mapDispatchToProps
)(BillingEventCapsComponent);

export default BillingEventCaps;
